//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';;
import { ServerApi, AILyricTaskStatus } from "src/utils.js"
import { formatID } from 'src/utils.js';
import NotifyMixin from 'src/mixins/Notification.js'

export default {
  name: 'AILyricCenter',

  // v-model: showAILyricCenter from MainLayout
  props: ['value'],

  mixins: [NotifyMixin],

  data() {
    return {
      // task defination: {
      //    "status": 5,
      //    "resourceUrl": "http://10.6.10.9:30148/api/media/download/1095047/1",
      //    "displayName": "1095047#\u7570\u4e16\u754c\u30d8\u30eb\u30b9\u3078\u3088\u3046\u3053\u305d \u30de\u30be\u5fa1\u7528\u9054 \u610f\u5730\u60aa\u30a8\u30eb\u30d5\u306e\u30aa\u30ca\u30b5\u30dd\u5c02\u9580\u5e97 \u30c9\u30b9\u30b1\u30d9\u30a8\u30eb\u30d5\u306b\u683c\u306e\u9055\u3044\u3092\u898b\u305b\u3064\u3051\u3089\u308c\u308b\u30aa\u30ca\u30cb\u30fc\u30b5\u30dd\u30fc\u30c8#1.\u7570\u4e16\u754c\u30d8\u30eb\u30b9\u3078\u3088\u3046\u3053\u305d(SE\u3042\u308a).WAV",
      //    "createdTime": 1698566933.293261,
      //    "mediaPath": "/Users/number17/Codes/dj_whisper/whisper-finetune-500h/cache/input/207776076030774225.WAV",
      //    "lrcPath": "/Users/number17/Codes/dj_whisper/whisper-finetune-500h/cache/output/207776076030774225.lrc",
      //    "id": 207776076030774225
      // },
      tasks: [],
      AILyricTaskStatus,
      formatID,

      filterWorkId: "",
      filterFileName: "",

      statusOption: [],
      statusOptions: Array(AILyricTaskStatus.COUNT).fill(0).map((_, i) => i),

      pagination: { currentPage:0, pageSize: 12, totalCount:0 },
      stopLoadingPage: false,

      autoRefresh: false, // 是否自动刷新
      autoRefreshIntervalMills: 5000, // 自动刷新间隔
    }
  },

  watch: {
    statusOption(v) {
      if (v === null) this.statusOption = [];
      this.resetLoadedData();
    },
    filterWorkId() {
      this.resetLoadedData();
    },
    filterFileName() {
      this.resetLoadedData();
    },
    filterStatus() {
      this.resetLoadedData();
    },
  },

  mounted() {
    this.resetLoadedData()
  },

  methods: {
    async resetLoadedData() {
      console.warn("resetLoadedData start, freeze scroller")
      this.stopLoadingPage = true; // freeze scroller first
      this.pagination = { currentPage:0, pageSize: 12, totalCount:0 };
      this.tasks = [];
      // Manually fetch first page content before enable scroller
      // Note: the internal API of the infinite scroller does not work well
      await this.loadFurtherTasks();
      this.stopLoadingPage = false; // unlock scroller
      console.warn("resetLoadedData finished, unfreeze scroller")
    },
    async loadFurtherTasks() {
      let page = null;
      try {
        page = await ServerApi.searchTask(
          this.pagination.currentPage + 1, 
          this.filterWorkId, 
          this.filterFileName, 
          this.statusOption,
        );
      } catch(error) {
        if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          if (error.response.status !== 401) {
            this.showErrNotif(error.response.data.error || `${error.response.status} ${error.response.statusText}`)
          }
        } else {
          this.showErrNotif(error.message || error)
        }
        this.stopLoadingPage = true;
        return;
      }

      this.pagination = page.pagination;
      this.tasks = page.pagination.currentPage === 1
        ? page.tasks
        : this.tasks.concat(page.tasks);
      if (this.tasks.length >= page.pagination.totalCount) {
        console.warn("all ai task loaded")
        this.stopLoadingPage = true;
      }
    },

    onLoad(_, done) {
      this.loadFurtherTasks().then(() => done())
    },

    readableStatus(status) {
      switch(status) {
        case AILyricTaskStatus.NONE:
          return "非法状态";
        case AILyricTaskStatus.PENDING:
          return "待执行";
        case AILyricTaskStatus.TRASCRIPTING:
          return "翻译中";
        case AILyricTaskStatus.SUCCESS:
          return "成功";
        case AILyricTaskStatus.ERROR:
          return "失败";
      }
    },

    async deleteTask(taskId) {
      this.$q.dialog({
        title: "删除翻译任务",
        message: "确认要删除翻译任务吗，字幕文件也会被一并删除，且无法恢复。",
        ok: "删除",
        cancel: "取消",
        persistent: false
      }).onOk(async () => {
        await ServerApi.deleteTask(taskId);
        this.resetLoadedData();
      });
    },

    async redoTask(taskId) {
      await ServerApi.redoTask(taskId);
      this.resetLoadedData();
    },

    openWorkDetail(work_id) {
      this.$router.push(`/work/${work_id}`)
    },

    samCoverUrl (work_id) {
      // 从 LocalStorage 中读取 token
      const token = this.$q.localStorage.getItem('jwt-token') || '';
      let prefix = '/api'
      if (work_id.slice(1,2) == ['j']) prefix = `/api/fake`;
      return `${prefix}/${work_id}?type=sam&token=${token}`;
    },

    copyToClipboard(content, hint) {
      copyToClipboard(`${content}`).then(() => {
        this.$q.notify({message: `已复制${hint}到剪切板`, timeout: 200});
      })
    }
  }
}
